import gql from 'graphql-tag';

export const GET_SLIDER_DATA = gql`
    query getSliderData{
        sliders{
            id
            desktopImage
            mobileImage
            altText
            reference
        }
    }
`;

export const GET_LOGIN_QUERY = gql`
    query getLoginQuery($email: String!, $password: String!){
        login(email: $email, password: $password)
    }
`;

export const GET_GOOGLE_ACCESS_TOKEN = gql`
    query getGoogleAccessToken($token: String!){
        google(accessToken: $token)
    }
`;

export const GET_FACEBOOK_ACCESS_TOKEN = gql`
    query getFacebookAccessToken($token: String!){
        facebook(accessToken: $token)
    }`;

export const LOG_OUT = gql`
    query logOut {
        logout
    }`;

export const CHECK_USER_NAME = gql`
    query checkUserName($userName: String!) {
        checkUserName(username: $userName)
    }
`;

export const GET_TESTIMONIALS_DATA = gql`
    query getTestimonials{
        testimonies {
            id
            name
            message
            userInfo
            picture
            altTxt
            page
        }
    }
`;

export const GET_USER_DATA_AND_WALLET = gql`
    query getUserDataAndWallet{
        me{
            id
            name
            email
            avatarUrl
            userName
            contactNumber
            batch
            qualification
            specialization
            countryData{
                name
                dialCode
                countryCode
            }
            state
            university
            mbbsPercentage
            category
            emailVerified
        }
        getWallet{
            serum
            cash
        }
    }`;

export const GET_WALLET_DATA = gql`
    query getWalletData{
        getWallet{
            serum
            cash
        }
    }
`;

export const GET_SERUM_DATA = gql`
    query getSerumData {
        getWallet{
            serum
        }
    }
`;

export const GET_CASH_DATA = gql`
    query getCashData {
        getWallet{
            cash
        }
    }
`;

export const GET_HOMEPAGE_DATA = gql`
    query getHomepageData {
        sliders{
            id
            desktopImage
            mobileImage
            altText
            reference
        }
        challenges(first: 20, type: AllChallenges){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                    isNotified
                }
            }
        }
        tests(first: 10, type: ALL){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    isNotified
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    correctAnswerMarks
                    wrongAnswerMarks
                    ifAttempted{
                        testState
                    }
                }
            }
        }
        videosWeb(first:8){
            edges{
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    views
                    createdAt
                    updatedAt
                    isPrime
                    slug
                    completedStatus
                    author{
                        id
                        name
                    }
                }
            }
        }
        medpixxes(first: 10){
            edges{
                node{
                    id
                    title
                    medpixxImageUrl
                    medpixxImageAltText
                    slug
                }
            }
        }
        infomeds(first: 10){
            edges{
                node{
                    id
                    title
                    featuredImageUrl
                    slug
                    updatedAt
                    author{
                        name
                    }
                    serum
                }
            }
        }
    }
`;

export const GET_QUESTION_DETAILS = gql`
    query Question($id : String!){
        question(id: $id){
            questionType
            question
            questionMedia
            questionBasis
            options
        }
    }
`;

export const GET_MASTER_NOTE = gql`
    query getMasterNote($id: String!){
        masterNote(id: $id){
            title
            introduction
            notes{
                id
                title
            }
        }
    }
`;

export const GET_NOTE_DATA = gql`
    query getNoteData($id: String!){
        note(id: $id){
            description
            tags
            ref
        }
    }`;

export const NOTIFY_CHALLENGE = gql`
    mutation notifyChallenge($id: String!){
        notifyChallenz(challenzId: $id)
    }`;

export const NOTIFY_TEST = gql`
    mutation notifyTest($id:String!){
        notifyTest(testId: $id)
    }
`;
export const REPORT_QUESTION = gql`
    query reportQuestion($errorType:String!,$Comment:String!,$questionId:String!){
        reportQuestion(errorType:$errorType,Comment:$Comment,questionId:$questionId)
    }`;

export const GET_CHALLENGE_QUESTION_EXPLANATION = gql`
    query challengeQuestionExplanation($id: String!, $challengeId: String!)   {
        questionExplanation(id: $id, postid: $challengeId, productType: MedChallenge) {
            id
            question
            questionType
            questionMedia
            questionBasis
            options
            explanation
            explanationVideoUrl
            correctAnswer
            isRibbon
            ribbonCount
            ref
            updatedOn
            optionsAnalysis
            userQuestionData{
                user_answer: userAnswer
                success
                isGuess
                timeSpent
            }
        }
    }
`;

export const GET_TEST_QUESTION_EXPLANATION = gql`
    query testQuestionExplanation($id: String!, $testId: String!){
        questionExplanation(id: $id, postid: $testId, productType: Prepmed) {
            id
            question
            questionType
            questionMedia
            questionBasis
            options
            explanation
            explanationVideoUrl
            correctAnswer
            isRibbon
            ribbonCount
            ref
            optionsAnalysis
            updatedOn
        }
    }
`;

export const STORE_TOKEN = gql`
    mutation StoreToken($token : String!){
        storeToken(token:$token) @client
    }
`;

export const STORE_PROFILE = gql`
    mutation StoreProfile($profile : User!){
        storeProfile(profile:$profile) @client
    }
`;

export const OPEN_MODAL = gql`
    mutation OpenModal($isOpen: Boolean!){
        open_Modal(isOpen: $isOpen) @client
    }
`;

export const START_EXAM = gql`
    mutation startExam($input: UserChallengeEvent!){
        addUserChallengeEvent(input: $input)
    }`
;

export const GET_OPEN_MODAL = gql`
    query GetopenModal{
        modal @client{
            isModal
        }
    }
`;

export const GET_LOGIN_STATUS = gql`
    query ReadAuth {
        isLogin @client {
            isAuthenticated
            token
        }
    }
`;

export const GET_PROFILE_INFO = gql`
    query Profile{
        userProfile @client{
            id
            name
            email
            mbbsPercentage
            state
            university
            userName
            countryData{
                name
                dialCode
                countryCode
            }
            emailVerified
            category
            contactNumber
            avatarUrl
        }
    }`;

export const GET_QUESTION_QUERY = gql`
    query question($id: String!) {
        question(id: $id) {
            question
        }
    }
`;

export const Add_User = gql`
    mutation addUser($input: UserSignUp!) {
        addUser(input: $input)
    }
`;

export const SEND_RESPONSE = gql`
    mutation addUserChallengeEvent($input: UserChallengeEvent!){
        addUserChallengeEvent(input:$input)
    }
`;

export const SEND_MEDPIX_CLAPS = gql`
    mutation addClaps($input: AddClap!){
        claps
    }
`;

export const GET_MEDPIX_DATA = gql`
    query medipxx_data($id: String!){
        medpixx(id: $id){
            id
            title
            description
            medpixxImageUrl
            medpixxImageAltText
            claps
            isRibbon
            ribbonCount
            isClapped
            ref
            backTalkCount
            subjects
            metaTitle
            metaDescription
            metaKeywords
            slug
        }
    }
`;

export const GET_RELATED_MEDPIXXES = gql`
    query medpixxesUpdated($cursor: String!, $subjects: [String!]){
        relatedMedPixxes: medpixxesUpdated(first: 9, after: $cursor, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    medpixxImageUrl
                    medpixxImageAltText
                    slug
                }
            }
        }
    }
`;

export const GET_BOOMARKED_MEDPIXX_DATA = gql`
    query medipxx_data($id : String!, $cursor : String!){
        medpixx(id: $id){
            id
            title
            description
            medpixxImageUrl
            medpixxImageAltText
            claps
            isRibbon
            ribbonCount
            isClapped
            ref
            metaTitle
            metaDescription
            metaKeywords
            slug
        }
        userRibbons(first: 12, after: $cursor, productType: Medpixx){
            edges{
                cursor
                node{
                    ... on Medpixx{
                        id
                        title
                        medpixxImageUrl
                        claps
                        isRibbon
                        ribbonCount
                        isClapped
                        medpixxImageAltText
                        slug
                    }
                }
            }
        }
    }
`;

export const GET_MEDPIXXES_DATA = gql`
    query medPixxesData($searchString: String!, $subjects: [String!]){
        medpixxesUpdated(first: 20, queryString: $searchString, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    medpixxImageUrl
                    claps
                    isRibbon
                    ribbonCount
                    isClapped
                    medpixxImageAltText
                    slug
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_BOOMARKED_MEDPIXXES_DATA = gql`
    query {
        userRibbons(first: 10, productType: Medpixx){
            edges{
                cursor
                node{
                    ... on Medpixx{
                        id
                        title
                        medpixxImageUrl
                        claps
                        isRibbon
                        ribbonCount
                        isClapped
                        medpixxImageAltText
                        slug
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MORE_BOOMARKED_MEDPIXXES_DATA = gql`
    query getMoreBookmarkedmedpixx($id:String!){
        userRibbons(first: 10, after:$id, productType: Medpixx){
            edges{
                cursor
                node{
                    ... on Medpixx{
                        id
                        title
                        medpixxImageUrl
                        claps
                        isRibbon
                        ribbonCount
                        isClapped
                        medpixxImageAltText
                        slug
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount

        }
    }
`;

export const GET_BOOKMARKED_QUESTION_DATA = gql`
    {
        userRibbons(first: 10, productType: MedChallenge){
            edges{
                cursor
                node{
                    ... on MedChallengeRibbon {
                        challenz{
                            id
                            title
                            slug
                        }
                        questionExplanation{
                            id
                            question
                            questionType
                            questionMedia
                            questionBasis
                            options
                            explanation
                            explanationVideoUrl
                            correctAnswer
                            isRibbon
                            ribbonCount
                            ref
                            updatedOn
                            optionsAnalysis
                            userQuestionData{
                                user_answer: userAnswer
                                success
                                isGuess
                                timeSpent
                            }
                        }
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_BOOKMARKED_PREPMED_QUESTIONS = gql`
    {
        userRibbons(first: 10, productType: Prepmed){
            edges{
                cursor
                node{
                    ... on PrepmedRibbon {
                        test{
                            id
                            title
                            slug
                        }
                        questionExplanation{
                            id
                            question
                            questionType
                            questionMedia
                            questionBasis
                            options
                            explanation
                            explanationVideoUrl
                            correctAnswer
                            isRibbon
                            ribbonCount
                            ref
                            optionsAnalysis
                            updatedOn
                            userQuestionData{
                                userAnswer
                                success
                                isGuess
                                timeSpent
                            }
                        }
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_BOOKMARKED_QUESTIONDATA = gql`
    query ($id : String!){
        userRibbons(first: 10, productType: MedChallenge, after:$id){
            edges{
                cursor
                node{
                    ... on MedChallengeRibbon {
                        challenz{
                            id
                            title
                            slug
                        }
                        questionExplanation{
                            id
                            question
                            questionType
                            questionMedia
                            questionBasis
                            options
                            explanation
                            explanationVideoUrl
                            correctAnswer
                            isRibbon
                            ribbonCount
                            ref
                            updatedOn
                            optionsAnalysis
                            userQuestionData{
                                user_answer: userAnswer
                                success
                                isGuess
                                timeSpent
                            }
                        }
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_BOOKMARKED_PREPMED_QUESTIONDATA = gql`
    query ($id:String!){
        userRibbons(first: 10, productType: Prepmed, after:$id){
            edges{
                cursor
                node{
                    ... on PrepmedRibbon {
                        test{
                            id
                            title
                            slug
                        }
                        questionExplanation{
                            id
                            question
                            questionType
                            questionMedia
                            questionBasis
                            options
                            explanation
                            explanationVideoUrl
                            correctAnswer
                            isRibbon
                            ribbonCount
                            ref
                            optionsAnalysis
                            updatedOn
                            userQuestionData{
                                userAnswer
                                success
                                isGuess
                                timeSpent
                            }
                        }
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_BOOMARKED_MVIDEOS_DATA = gql`
    query {
        userRibbons(first: 10, productType: TelevisionWeb){
            edges{
                cursor
                node{
                    ... on Video{
                        id
                        title
                        videoUrl
                        duration
                        videoThumbnail
                        videoDescription
                        claps
                        isRibbon
                        ribbonCount
                        isClapped
                        views
                        category{
                            id
                            name
                        }
                        subCategory{
                            id
                            name
                        }
                        subjects
                        isPrime
                        author{
                            id
                            name
                            avatarUrl
                        }
                        metaTitle
                        metaDescription
                        metaKeywords
                        slug
                        ref
                        createdAt
                        updatedAt
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount

        }
    }
`;

export const GET_MORE_BOOKMARKED_MVIDEOS = gql`
    query ($id:String!){
        userRibbons(first: 10, after:$id,productType: TelevisionWeb){
            edges{
                cursor
                node{
                    ... on Video{
                        id
                        title
                        videoUrl
                        duration
                        videoThumbnail
                        videoDescription
                        claps
                        isRibbon
                        ribbonCount
                        isClapped
                        views
                        categories
                        isPrime
                        author{
                            id
                            name
                            avatarUrl
                        }
                        metaTitle
                        metaDescription
                        metaKeywords
                        slug
                        ref
                        createdAt
                        updatedAt
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MORE_MEDPIXXES_DATA = gql`
    query medPixxesData($cursor: String!, $searchString: String!, $subjects: [String!]){
        medpixxesUpdated(first: 20, after: $cursor, queryString: $searchString, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    medpixxImageUrl
                    medpixxImageAltText
                    slug
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MORE_INFOMED_DATA = gql`
    query getMoreInfomed($id: String!, $searchString: String!, $subjects: [String!]){
        infomedsUpdated(first: 10, after: $id, queryString: $searchString, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    shortDescription
                    featuredImageUrl
                    featuredImageAltText
                    isRibbon
                    ribbonCount
                    claps
                    isClapped
                    slug
                    updatedAt
                    author{
                        name
                    }
                    serum
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_INFOMED_DATA = gql`
    query infoMedData($searchString: String!, $subjects: [String!]){
        infomedsUpdated(first: 10, queryString: $searchString, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    shortDescription
                    featuredImageUrl
                    featuredImageAltText
                    isRibbon
                    ribbonCount
                    claps
                    isClapped
                    slug
                    updatedAt
                    author{
                        name
                    }
                    serum
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_INFOMED_DETAILED_DATA = gql`
    query getInfomedDetailedData($id: String!){
        infomed(id: $id){
            id
            title
            description
            featuredImageUrl
            featuredImageAltText
            ref
            claps
            isRibbon
            ribbonCount
            isClapped
            serum
            eligible
            metaTitle
            metaDescription
            metaKeywords
            slug
            updatedAt
            author{
                name
                avatarUrl
            }
            serum
            backTalkCount
        }
    }
`;

export const UNLOCK_INFOMED = gql`
    mutation unlockInfoMed($id: String!){
        unlockInfomed(id: $id)
    }
`;

export const TOGGLE_BOOKMARK = gql`
    mutation toggle_bookmark($input: ToggleRibbon!){
        toggleRibbon(input: $input)
    }
`;

export const TOGGLE_WATCHED = gql`
    query toggle_watched($id: String!){
        toggleCompletedStatus(id: $id)
    }
`;

export const CLAP_ACTION = gql`
    mutation clap_action($input:AddClap!){
        addClaps(input : $input){
            claps
        }
    }
`;

export const GET_BOOKMARKED_INFOMED_DATA = gql`
    query Bookmarks {
        userRibbons(first: 10, productType: Infomed){
            edges{
                cursor
                node{
                    ... on Infomed{
                        id
                        title
                        shortDescription
                        featuredImageUrl
                        featuredImageAltText
                        isRibbon
                        ribbonCount
                        claps
                        isClapped
                        slug
                        updatedAt
                        author{
                            name
                        }
                        serum
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_COMPLETED_CHALLENGES_LIST = gql`
    {
        completedChallenges(first: 10){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }

    }
`;
export const GET_MORE_COMPLETED_CHALLENGES_LIST = gql`
    query completedChallengesList($id:String!){
        completedChallenges(first: 10,after:$id){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }

    }
`;

export const ADD_VIEW = gql`
    mutation addview($id: String!){
        addView(id: $id)
    }
`;

export const GET_MVIDEOS = gql`
    query getMvideos($cursor: String!, $searchString: String!, $subjects: [String!]){
        videosSearchWeb(first: 10, after: $cursor, queryString: $searchString, subjects: $subjects) {
            edges{
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    isPrime
                    views
                    createdAt
                    completedStatus
                    updatedAt
                    slug
                    author{
                        id
                        name
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MVIDEO_DATA_IN_EXPLANATION = gql`
    query($id:String!){
        videoWeb(id: $id){
            id
            title
            videoUrl
            videoThumbnail
            isPrime
        }
    }`;

export const GET_MVIDEO_DETAILED = gql`
    query($id:String!){
        videoWeb(id: $id){
            id
            title
            videoUrl
            duration
            videoThumbnail
            videoDescription
            claps
            isRibbon
            ribbonCount
            isClapped
            views
            subjects
            category{
                id
                name
            }
            subCategory{
                id
                name
            }
            isPrime
            author{
                id
                name
                avatarUrl
            }
            backTalkCount
            metaTitle
            metaDescription
            metaKeywords
            completedStatus
            slug
            ref
            mNotesUrl
            createdAt
            updatedAt
        }
    }`;

export const GET_MVIDEOS_CATEGORIES_AND_VIDEOS = gql`
    query ($trays: Int!, $first: Int!){
        categoryList(first: 20, pageNumber: 0, trayFetched: $trays){
            categories{
                id
                name
            }
            hasNextPage
        }
        videosUpdatedWeb(trays: $trays, first: $first){
            categoryId
            categoryName
            videos{
                id
                title
                videoUrl
                duration
                videoThumbnail
                category{
                    id
                    name
                }
                subCategory{
                    id
                    name
                }
                isPrime
                views
                createdAt
                updatedAt
                slug
                completedStatus
                author{
                    id
                    name
                }
            }
        }
    }
`;

export const GET_MORE_MVIDEOS_CATEGORIES = gql`
    query ($pageNumber: Int!, $traysFetched: Int!){
        categoryList(first: 20, pageNumber: $pageNumber, trayFetched: $traysFetched){
            categories{
                id
                name
            }
            hasNextPage
        }
    }
`;

export const GET_MVIDEOS_SUB_CATEGORIES = gql`
    query ($videoCount: Int!, $categoryId: String!){
        categoryVideosWeb(first: $videoCount, categoryId: $categoryId){
            categoryName
            subCategories{
                subCategoryId
                subCategoryName
                videos{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    isPrime
                    views
                    createdAt
                    updatedAt
                    completedStatus
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    slug
                    author{
                        id
                        name
                    }
                }
            }
        }
    }
`;

export const GET_MVIDEOS_OF_SUB_CATEGORIES = gql`
    query ($categoryId: String!, $subCategoryId: String!){
        subCategoryVideosWeb(first: 10, categoryId: $categoryId, subCategoryId: $subCategoryId){
            categoryName
            subCategoryName
            edges{
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    isPrime
                    views
                    createdAt
                    completedStatus
                    updatedAt
                    slug
                    author{
                        id
                        name
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_MVIDEOS_OF_SUB_CATEGORIES = gql`
    query ($endCursor: String!, $categoryId: String!, $subCategoryId: String!){
        subCategoryVideosWeb(first: 10, categoryId: $categoryId, subCategoryId: $subCategoryId, after: $endCursor){
            categoryName
            subCategoryName
            edges{
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    isPrime
                    views
                    createdAt
                    updatedAt
                    slug
                    author{
                        id
                        name
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_RELATED_MVIDEOS = gql`
    query getRelatedMvideos($cursor: String!, $subjects: [String!]){
        relatedMVideos: videosSearchWeb(first: 10, after: $cursor, subjects: $subjects) {
            edges{
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    isPrime
                    views
                    createdAt
                    completedStatus
                    updatedAt
                    slug
                    author{
                        id
                        name
                    }
                }
            }
        }
    }
`;

export const GET_MVIDEOS_DATA = gql` {
    videos(first:20){
        edges{
            cursor
            node{
                id
                title
                videoUrl
                duration
                videoThumbnail
                category{
                    id
                    name
                }
                subCategory{
                    id
                    name
                }
                isPrime
                views
                createdAt
                updatedAt
                slug
                author{
                    id
                    name
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
        totalCount
    }
}
`;

export const GET_MORE_MVIDEOS_DATA = gql`
    query ($id: String!){
        videos(first:20, after:$id){
            edges{
                cursor
                node{
                    id
                    title
                    videoUrl
                    duration
                    videoThumbnail
                    videoAltText
                    videoDescription
                    views
                    subjects
                    category{
                        id
                        name
                    }
                    subCategory{
                        id
                        name
                    }
                    isPrime
                    metaTitle
                    metaKeywords
                    metaDescription
                    views
                    updatedAt
                    slug
                    ref
                    createdAt
                    updatedAt
                    author{
                        id
                        name
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;
export const GET_COMPLETED_CHALLENGE_DETAILED_DATA = gql`
    query completedChallenge($id:String!){
        challenge(id: $id){
            id
            title
            description
            featuredImageUrl
            featuredImageAltText
            questionCount
            questionIds
            totalTime
            startTime
            endTime
            slug
            masterNoteId
            isNotified
            isMasterNotePrime
            videoExplanation
            isVideoExplanationPrime
            ifChallenzed {
                challenzState
                medal
            }
        }
        completedChallenges(first: 8){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MORE_BOOKMARKED_INFOMED_DATA = gql`
    query MoreBookmarks($id:String!) {
        userRibbons(first: 10,after:$id productType: Infomed){
            edges{
                cursor
                node{
                    ... on Infomed{
                        id
                        title
                        shortDescription
                        featuredImageUrl
                        featuredImageAltText
                        isRibbon
                        ribbonCount
                        claps
                        isClapped
                        slug
                        updatedAt
                        author{
                            name
                        }
                        serum
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const CHECK_USERNAME = gql`
    query checkexistinguser($username : String!){
        checkUserName(username : $username)
    }
`;

export const GET_TEST_DATA = gql`
    query GetTestData($id: String!) {
        test(id: $id){
            id
            title
            basis
            description
            slug
            totalTime
            totalMarks
            testMode
            serum
            questionIds
            featuredImageUrl
            featuredImageAltText
            startTime
            isPrime
            endTime
            questionCount
            wrongAnswerMarks
            correctAnswerMarks
            ifAttempted {
                testState
                mode
            }
            backTalkCount
            metaTitle
            metaDescription
            metaKeywords
        }
    }`;

export const GET_TESTS_DATA = gql`
    query GET_TESTS_DATA($queryString:String!,$examTypes:[TestType!]){
        testsUpdated(first: 20,queryString: $queryString,examTypes: $examTypes){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    correctAnswerMarks
                    wrongAnswerMarks
                    featuredImageUrl
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_TESTS_DATA = gql`
    query GET_MORE_TESTS_DATA($queryString:String!,$examTypes:[TestType!],$after:String!){
        testsUpdated(first: 20,after:$after, queryString: $queryString,examTypes: $examTypes){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    correctAnswerMarks
                    wrongAnswerMarks
                    featuredImageUrl
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_OTHER_TESTS_DATA = gql`
    query GET_OTHER_TESTS_DATA($type: TestType!){
        tests(first: 9, type: $type){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    correctAnswerMarks
                    wrongAnswerMarks
                    featuredImageUrl
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
    }
`;

export const PRACTICE_MODE = gql`
    query PracticeMode($id: String!){
        practiceModeEvent(id: $id)
    }
`;

export const GET_TEST_AND_SESSION_DATA = gql`
    query GetTestData($id: String!) {
        test(id: $id){
            id
            title
            basis
            testMode
            serum
            slug
            totalTime
            questionIds
            startTime
            endTime
            questionCount
            ifAttempted {
                testState
                lastQuestionIndex
                timeRemaining
                mode
            }
        }
        userTestSession(testId: $id)
        getTime
    }`;

export const GET_TEST_QUESTION_DATA = gql`
    query getTestQuestionData($id: String!){
        testQuestionsData(id: $id)
    }
`;

export const TEST_ANSWERED_EVENT = gql`
    mutation TestAnsweredEvent($input: UserTestEvent!) {
        addUserTestEvent(
            input: $input
        )
    }`;

export const Action = gql`
    enum Action {
        Start
        Progressed
        Answered
        Submit
    }
`;

export const GET_COMPLETED_TESTS = gql`
    query compTests{
        completedTests(first:10){
            edges{
                node{
                    id
                    title
                    metaTitle
                    metaKeywords
                    metaKeywords
                    description
                    featuredImageUrl
                    featuredImageAltText
                    endTime
                    startTime
                    basis
                    slug
                    totalTime
                    isPrime
                    questionIds
                    questionCount
                    difficulty
                    description
                    correctAnswerMarks
                    wrongAnswerMarks
                    ifAttempted{
                        testState
                        lastQuestionIndex
                        timeRemaining
                    }
                    metaKeywords
                    isPrime
                }
                cursor
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MORE_COMPLETED_TESTS = gql`
    query compTests($id:String!){
        completedTests(first:10, after:$id){
            edges{
                node{
                    id
                    title
                    metaTitle
                    metaKeywords
                    metaKeywords
                    description
                    featuredImageUrl
                    featuredImageAltText
                    endTime
                    startTime
                    basis
                    slug
                    totalTime
                    isPrime
                    questionIds
                    questionCount
                    difficulty
                    description
                    correctAnswerMarks
                    wrongAnswerMarks
                    ifAttempted{
                        testState
                        lastQuestionIndex
                        timeRemaining
                    }
                    metaKeywords
                    isPrime
                }
                cursor
            }
            pageInfo{
                endCursor
                hasNextPage
            }
            totalCount
        }
    }
`;

export const GET_MEDBOOK = gql`
    query medbook{
        web{
            id
            investigations{
                name
                investigation{
                    conceptAnalysis{
                        core{
                            correct
                            inCorrect
                        }
                        capsule{
                            correct
                            inCorrect
                        }
                        cortex{
                            correct
                            inCorrect
                        }
                    }
                    guessAnalysis{
                        core{
                            correct
                            inCorrect
                        }
                        capsule{
                            correct
                            inCorrect
                        }
                        cortex{
                            correct
                            inCorrect
                        }
                    }
                }
            }
        }
        medalCount{
            gold
            silver
            bronze
        }
        levelCount{
            currentLevel
            currentLevelXP
            xpCountForNextLevel
        }
        comparitiveAnalysis{
            userAnalysis{
                name
                percentage
                id
            }
            topperAnalysis{
                name
                percentage
                id
            }
        }
        trophyStatus{
            targetStatus{
                targetName
                status
            }
            completedStatus
            expiresOn
            completedPercentage
        }
        trophyCount{
            count
        }
    }`;

// Challenge related schemas
export const GET_CHALLENGES_LIST_AND_ANALYSIS = gql`
    query challengesAndAnalysis($queryString:String!,$subjects:[String!]){
        challengesUpdated(first: 20, queryString: $queryString,subjects: $subjects){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    isNotified
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
        challenzesAnalysis {
            averagePercentage
            lastFivePercentages{
                id
                name
                percentage
            }
            lastFiveMaxPercentage
        }
        trophyStatus{
            targetStatus{
                targetName
                status
            }
            completedStatus
            expiresOn
        }
    }`;

export const GET_MORE_CHALLENGES_LIST_AND_ANALYSIS = gql`
    query morechallengesAndAnalysis($queryString:String!,$subjects:[String!],$after:String!){
        challengesUpdated(first: 20,after:$after, queryString: $queryString,subjects: $subjects){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    isNotified
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }`;

export const GET_CHALLENGES = gql`
    query getChallenges($cursor: String!, $queryString: String!, $subjects: [String!]){
        challengesUpdated(first: 20, after: $cursor, queryString: $queryString, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    isNotified
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_CHALLENGES_ANALYSIS = gql`
    query ChallengePageAnalysis{
        challenzesAnalysis {
            averagePercentage
            lastFivePercentages{
                id
                name
                percentage
            }
            lastFiveMaxPercentage
        }
        trophyStatus{
            targetStatus{
                targetName
                status
            }
            completedStatus
            expiresOn
        }
    }
`;

export const GET_FILTERED_CHALLENGES = gql`
    query getFilteredChallenges($first: Int!, $type: ChallengeQueryType!,$filter: String!){
        challenges(first: $first, type: $type, filter:$filter){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    isNotified
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
        challenzesAnalysis {
            averagePercentage
            lastFivePercentages{
                id
                name
                percentage
            }
            lastFiveMaxPercentage
        }
        trophyStatus{
            targetStatus{
                targetName
                status
            }
            completedStatus
            expiresOn
        }
    }
`;

export const GET_MORE_FILTERED_CHALLENGES = gql`
    query getMoreFilteredChallenges($first: Int!, $after:String!, $type: ChallengeQueryType!,$filter: String!){
        challenges(first: $first, after: $after, type: $type, filter:$filter){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    isNotified
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
    }
`;

export const GET_CHALLENGES_BY_TYPE = gql`
    query getChallengesByType($first: Int!, $type: ChallengeQueryType!){
        challenges(first: $first, type: $type){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    isNotified
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
    }
`;

export const GET_MORE_CHALLENGES_BY_TYPE = gql`
    query getMoreChallengesByType($first: Int!,$cursor: String!, $type: ChallengeQueryType!){
        challenges(first: $first, after: $cursor, type: $type){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    isNotified
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
    }
`;

export const GET_CHALLENGE_DATA = gql`
    query getChallengeData($id: String!){
        challenge(id: $id){
            id
            title
            slug
            totalTime
            questionIds
            startTime
            endTime
            isPrime
            questionCount
            ifChallenzed{
                challenzState
                timeRemaining
                lastQuestionIndex
            }
        }
    }`;

export const GET_CHALLENGE_DATA_AND_LIST_BL = gql`
    query getChallengeDataAndListBl($id: String!) {
        challenge(id: $id){
            id
            title
            description
            featuredImageUrl
            featuredImageAltText
            questionIds
            questionCount
            isPrime
            totalTime
            startTime
            endTime
            subjects
            ifChallenzed{
                challenzState
                medal
            }
            backTalkCount
            isNotified
            metaTitle
            metaDescription
            difficulty
            metaKeywords
            slug
        }
    }`;

export const GET_CHALLENGE_DATA_AND_LIST_AL = gql`
    query getChallengeDataAndListAl($id: String!) {
        challenge(id: $id){
            id
            title
            description
            featuredImageUrl
            featuredImageAltText
            questionIds
            questionCount
            totalTime
            startTime
            endTime
            subjects
            isPrime
            masterNoteId
            isMasterNotePrime
            videoExplanation
            isNotified
            isVideoExplanationPrime
            ifChallenzed{
                challenzState
                medal
            }
            backTalkCount
            metaTitle
            metaDescription
            difficulty
            metaKeywords
            slug
        }
    }`;

export const GET_CHALLENGE_INFO = gql`
    query getChallengeInfo($id: String!){
        challenzAnalysis(id: $id) {
            id
            title
            medal
            score
            challenzCorrectness
            questionAnalysis {
                success
                questionIndex
                isGuess
                timeSpent
                userAnswer
            }
            bellCurve{
                mean
                standardDeviation
            }
        }
    }
`;

export const GET_RELATED_CHALLENGES = gql`
    query getRelatedChallenges($cursor: String!, $subjects: [String!]){
        relatedChallenges: challengesUpdated(first: 9, after: $cursor, subjects: $subjects){
            edges{
                node{
                    id
                    title
                    description
                    featuredImageUrl
                    isPrime
                    questionCount
                    totalTime
                    startTime
                    endTime
                    difficulty
                    slug
                    ifChallenzed {
                        challenzState
                        medal
                    }
                }
            }
        }
    }
`;

export const GET_CHALLENGE_ANALYSIS = gql`
    query challengeAnalysis($id: String!){
        challenzAnalysis(id: $id) {
            id
            title
            medal
            score
            challenzCorrectness
            questionAnalysis {
                success
                questionIndex
                isGuess
                timeSpent
                userAnswer
            }
            bellCurve{
                mean
                standardDeviation
            }
            topperAnalysis{
                score
                questionAnalysis{
                    questionId
                    questionIndex
                    success
                    isGuess
                    timeSpent
                    userAnswer
                }
            }
            challenzersCount
        }
        leaderBoard(id: $id, pageNumber: 0){
            rank
            user{
                name
                avatarUrl
            }
            medal
            score
        }
        rank(id: $id){
            rank
            user{
                name
                avatarUrl
            }
            medal
            score
        }
    }
`;

export const CHALLENGE_START_EVENT = gql`
    mutation challengeStartEvent($id: String!){
        addUserChallengeEvent(input : {
            challenzId: $id,
            questionIndex: 0,
            action: Start,
            timer: 0
        })
    }
`;

export const TEST_START_EVENT = gql`
    mutation testStartEvent($id: String!){
        addUserTestEvent(input : {
            testId: $id,
            action: Start,
            questionIndex: 0,
            timer: 0
        })
    }
`;

export const CHALLENGE_PROGRESSED_EVENT = gql`
    mutation challengeProgressedEvent($input: UserChallengeEvent!){
        addUserChallengeEvent(input: $input)
    }`;

export const TEST_PROGRESSED_EVENT = gql`
    mutation testProgressedEvent($input: UserTestEvent!){
        addUserTestEvent(input: $input)
    }`;

export const TEST_PARTIAL_SUBMIT_EVENT = gql`
    mutation testPartialSubmitEvent($input: UserTestEvent!){
        addUserTestEvent(input: $input)
    }`;

export const TEST_SUBMIT_EVENT = gql`
    mutation testSubmitEvent($input: UserTestEvent!){
        addUserTestEvent(input: $input)
    }`;

export const CHALLENGE_ANSWERED_EVENT = gql`
    mutation challengeAnsweredEvent($input: UserChallengeEvent!) {
        addUserChallengeEvent(
            input: $input
        )
    }`;

export const CHALLENGE_SUBMIT_EVENT = gql`
    mutation challengeSubmitEvent($input: UserChallengeEvent!) {
        addUserChallengeEvent(input: $input)
    }`;

export const CHALLENGE_FEEDBACK_ONE = gql`
    mutation challengeFeedbackOne($input: Feedback!){
        addFeedback(input: $input)
    }`;

export const CHALLENGE_FEEDBACK_TWO = gql`
    mutation challengeFeedbackTwo($input: Feedback!){
        addFeedback(input: $input)
    }`;

export const CHALLENGE_FEEDBACK_THREE = gql`
    mutation challengeFeedbackThree($input: Feedback!){
        addFeedback(input: $input)
    }`;

export const TEST_FEEDBACK = gql`
    mutation challengeFeedbackThree($input: Feedback!){
        addFeedback(input: $input)
    }`;

export const TEST_ANALYSIS = gql`
    query($id: String!){
        testAnalysis(id: $id) {
            id
        }
    }`;

export const VERIFY_PAYMENTS = gql`
    query Verify_Payments($orderId:String!,$paymentId:String!,$signature:String!){
        verifyPayments(orderId:$orderId,paymentId:$paymentId,signature:$signature)
    }`;

export const GET_CHALLENGE_MEDAL = gql`
    query getChallengeMedal($id: String!){
        challenzAnalysis(id: $id) {
            medal
            serum
        }
        getWallet{
            serum
            cash
        }
    }`;

// Prepmed related schemas
export const GET_ALL_TESTS = gql`
    query AllTests{
        neetPgTests:tests(first: 20, type: NEETPG){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    correctAnswerMarks
                    wrongAnswerMarks
                    featuredImageUrl
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
        aiimsPgTests:tests(first: 20, type: AIIMSPG){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    startTime
                    correctAnswerMarks
                    wrongAnswerMarks
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
        usmleTests:tests(first: 20, type: USMLE){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    correctAnswerMarks
                    wrongAnswerMarks
                    featuredImageUrl
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
        upscTests:tests(first: 20, type: UPSCCMS){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    correctAnswerMarks
                    wrongAnswerMarks
                    startTime
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
        subjectWiseTests: tests(first: 20, type: SubjectWise){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    startTime
                    correctAnswerMarks
                    wrongAnswerMarks
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
        customTests:tests(first: 20, type: CustomType){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    startTime
                    correctAnswerMarks
                    wrongAnswerMarks
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
        }
    }`;

export const GET_TEST_BY_TYPE = gql`
    query getTestByType($first:Int!, $type: TestType!) {
        tests(first: $first, type: $type){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    startTime
                    correctAnswerMarks
                    wrongAnswerMarks
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
    }
`;

export const GET_MORE_TEST_BY_TYPE = gql`
    query getMoreTestByType($first:Int!,$cursor: String!, $type: TestType!) {
        tests(first: $first, after: $cursor, type: $type){
            edges{
                node{
                    id
                    title
                    description
                    basis
                    totalTime
                    totalMarks
                    testMode
                    serum
                    questionCount
                    featuredImageUrl
                    startTime
                    correctAnswerMarks
                    wrongAnswerMarks
                    endTime
                    featuredImageAltText
                    isPrime
                    slug
                    ifAttempted{
                        testState
                        mode
                    }
                }
            }
            pageInfo{
                hasNextPage
                endCursor
            }
        }
    }
`;

export const GET_TEST_ANALYSIS = gql`
    query getTestAnalysis($id: String!) {
        testAnalysis(id: $id){
            id
            title
            score
            testCorrectness
            bellCurve{
                mean
                standardDeviation
            }
            topperScore
            testersCount
            subjectAnalysis{
                subject
                correctPercentage
            }
        }
        testLeaderBoard(id: $id, pageNumber: 0){
            user{
                name
                avatarUrl
            }
            rank
            score
        }
        testRank(id: $id){
            user{
                name
                avatarUrl
            }
            rank
            score
        }
    }`;

export const GET_TEST_INFO = gql`
    query getTestInfo($id: String!) {
        testAnalysis(id: $id){
            id
            title
            score
            testCorrectness
            timeSpent
            bellCurve{
                mean
                standardDeviation
            }
            topperScore
            testersCount
            subjectAnalysis{
                subject
                correctPercentage
            }
        }
    }
`;

export const GET_MEDPASS_LIST = gql`
    query getMedPassList {
        medpassList {
            id
            title
            numberOfSubs
            description
            subscriptionModel
            subscriptionType
            price
            offerPrice
            serum
            offerValid
        }
    }
`;

// Payments
export const INITIATE_SEMESTER_PAYMENT = gql`
    query semester_sub($prime:Boolean!){
        initiatePayment(subscriptionType: Semester,prime:$prime)
    }`;

export const INITIATE_MONTHLY_PAYMENT = gql`
    query monthy_sub($id: String!, $redeemWithWallet: Boolean!){
        initiatePayment(id: $id, redeemWithWallet:$redeemWithWallet, platform: WEB){
            orderId
            medpassActive
        }
    }`;

export const ORDER_DETAILS = gql`
    {
        orderDetails{
            startDate
            title
            expiryDate
        }
    }
`;

//Contact us
export const CONTACT_US = gql`
    mutation contactUs($input: ContactUs!){
        contactUs(input: $input)
    }
`;

export const FORGOT_PASSWORD = gql`
    query forgotPassword($email: String!){
        requestForgotPassword(email: $email)
    }
`;

export const ACCEPT_FORGOT_PASSWORD = gql`
    query($token:String!,$newPassword:String!){
        acceptForgotPassword(
            token:$token,
            newPassword:$newPassword
        )
    }
`;

//USER PROFILE
export const UPDATE_USER_PROFILE = gql`
    mutation updateUserProfile($input: UserInput!){
        updateUserProfile(input:$input)
    }`;

export const UPDATE_PASSWORD = gql`
    mutation($oldPassword:String!,$newPassword:String!){
        updatePassword(oldPassword: $oldPassword, newPassword: $newPassword)
    }
`;

export const FETCH_COLLEGES = gql`
    query ($id: String!){
        colleges(name:$id)
    }
`;

export const VERIFY_EMAIL = gql`
    mutation($token: String!){
        emailVerification(token:$token)
    }`;

export const RESEND_EMAIL = gql`
    query {
        resendEmailVerification
    }
`;

export const ME = gql`{
    me{
        id
        name
        email
        avatarUrl
        userName
        contactNumber
        batch
        qualification
        specialization
        countryData{
            name
            dialCode
            countryCode
        }
        state
        university
        mbbsPercentage
        category
        emailVerified
    }
}`;

export const GET_COMMENTS = gql`
    query getComments($first: Int!, $postId: String!, $productType: ProductType!) {
        getBackTalks(first: $first, postId: $postId, productType: $productType){
            edges{
                node{
                    backtalkId
                    message
                    userInfo{
                        id
                        name
                        avatarUrl
                    }
                    updatedAt
                    replyCount
                }
                cursor
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_COMMENTS = gql`
    query getMoreComments($first: Int!, $after: String!, $postId: String!, $productType: ProductType!) {
        getBackTalks(first: $first, after: $after, postId: $postId, productType: $productType){
            edges{
                node{
                    backtalkId
                    message
                    userInfo{
                        id
                        name
                        avatarUrl
                    }
                    updatedAt
                    replyCount
                }
                cursor
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;

export const ADD_COMMENT = gql`
    mutation addComment($postId: String!, $productType: ProductType!, $message: String!){
        addBackTalk(postId: $postId, productType: $productType, message: $message){
            node{
                backtalkId
                message
                userInfo{
                    id
                    name
                    avatarUrl
                }
                updatedAt
                replyCount
            }
            cursor
        }
    }
`;

export const UPDATE_COMMENT = gql`
    mutation updateComment($commentId: String!, $commentText: String!){
        updateBackTalk(backtalkId: $commentId, message: $commentText)
    }
`;

export const UPDATE_INNER_COMMENT = gql`
    mutation updateInnerComment($commentId: String!, $commentText: String!){
        updateReplyBackTalk(backtalkId: $commentId, message: $commentText)
    }
`;

export const DELETE_COMMENT = gql`
    mutation deleteComment($commentId: String!){
        deleteBackTalk(backtalkId: $commentId)
    }
`;

export const DELETE_INNER_COMMENT = gql`
    mutation deleteInnerComment($commentId: String!){
        deleteReplyBackTalk(backtalkId: $commentId)
    }
`;

export const ADD_REPLY_TO_COMMENT = gql`
    mutation addReplyToComment($postId: String!, $productType: ProductType!, $commentId: String!, $commentText: String!){
        addReplyBackTalk(postId: $postId, productType: $productType, message: $commentText, replyToId: $commentId){
            node {
                backtalkId
                message
                userInfo {
                    id
                    name
                    avatarUrl
                }
                updatedAt
                replyCount
            }
            cursor
        }
    }
`;

export const GET_COMMENT_REPLIES = gql`
    query getCommentReplies($first: Int!, $postId: String!, $productType: ProductType!, $replyToId: String!){
        getReplyBackTalks(
            first: $first,
            postId: $postId,
            productType: $productType,
            replyToId: $replyToId
        ) {
            edges {
                node {
                    backtalkId
                    message
                    userInfo {
                        id
                        name
                        avatarUrl
                    }
                    updatedAt
                    replyCount
                }
                cursor
            }
            pageInfo {
                endCursor
                hasNextPage
            }
        }
    }
`;

export const GET_MORE_COMMENT_REPLIES = gql`
    query getCommentReplies($first: Int!,$after: String!, $postId: String!, $productType: ProductType!, $replyToId: String!){
        getReplyBackTalks(
            first: $first,
            after: $after,
            postId: $postId,
            productType: $productType,
            replyToId: $replyToId
        ) {
            edges {
                node {
                    backtalkId
                    message
                    userInfo {
                        id
                        name
                        avatarUrl
                    }
                    updatedAt
                    replyCount
                }
                cursor
            }
            pageInfo {
                endCursor
                hasNextPage
            }
        }
    }
`;

export const SEND_OTP = gql`
    mutation ($mobile: String!, $dialCode: String!, $countryCode: String!, $name: String!){
        sendOTP(contactNumber: $mobile, countryData:{
            dialCode: $dialCode
            countryCode: $countryCode
            name: $name
        })
    }
`;

export const GET_PLAY_AND_WIN_LEADERBOARD_DATA = gql`
    query walletLeaderBoard{
        walletLeaderBoard{
            user{
                id
                name
                avatarUrl
            }
            amount
        }
    }
`;
